import { Factory } from '../../services/Factory';

namespace app.directives.controls {

  export interface IComboBoxScope extends angular.IScope {
    data: any;
    options: any;
    serviceUrl: string;
    placeholderText: string;
    allowFreeEntries: boolean;
    allowDuplicates: boolean;
    selectionStacked: boolean;
    selectionPosition: string;
    styleMatchedEntries: boolean;
    enableEditing: boolean;
    displayNameKey?: string;
    icon?: string;
    disabled: boolean;
    maxSelection: number;
    maxSelectionText: string;
  }

  export interface IComboBoxAttributes extends angular.IAttributes {
  }

  export class ComboBox implements angular.IDirective {
    public restrict: string = 'E';
    public link: (scope: IComboBoxScope, element: angular.IAugmentedJQuery, attrs: IComboBoxAttributes) => void;
    public template: string;
    public scope = {
      data: '=ngModel',
      options: '=options',
      placeholderText: '@placeholderText',
      serviceUrl: '@serviceUrl',
      allowFreeEntries: '=',
      allowDuplicates: '=',
      selectionStacked: '=',
      selectionPosition: '=',
      styleMatchedEntries: '=',
      enableEditing: '=',
      icon: '@',
      disabled: "=",
      maxSelection: "=",
      maxSelectionText: "@maxSelectionText"
    };

    public require = ['ngModel'];

    constructor(configService: app.services.IConfigService, tokenService: TokenService) {
      this.template = `<div class="row"><div class="col-md-12"><input id="combobox" class="form-control" /></div></div>`;
      this.link = (scope: IComboBoxScope, element: angular.IAugmentedJQuery) => {
        scope.displayNameKey = scope.displayNameKey ?? "name";

        let combobox = (<any>element).find("#combobox").magicSuggest({
          selectionPosition: scope.selectionPosition ? scope.selectionPosition : "inner",
          selectionStacked: scope.selectionStacked,
          value: [],
          allowDuplicates: scope.allowDuplicates,
          placeholder: scope.placeholderText,
          data: scope.serviceUrl ? `${configService.getServerBaseUrl()}${scope.serviceUrl}` : null,
          ajaxConfig: {
            beforeSend: (xhr: XMLHttpRequest) => {
              const token = tokenService.GetAccessToken();
              if (token) xhr.setRequestHeader('Authorization', 'Bearer ' + token);
            }
          },
          maxDropHeight: scope.serviceUrl || scope.options ? 290 : 0,
          cls: scope.serviceUrl || scope.options ? "" : "magicSuggest",
          hideTrigger: scope.serviceUrl === undefined && scope.options === undefined,
          allowFreeEntries: scope.allowFreeEntries,
          method: "get",
          maxSelection: scope.maxSelection ?? 200,
          useZebraStyle: true,
          renderer: data => ComboBox.HtmlEscape(data.name),
          selectionRenderer: (data: any) => {
            let display: string;

            if (data.name?.length > 30) {
              display = data.name.substring(0, 30) + " ..";
            } else {
              display = data.name;
            }

            display = ComboBox.HtmlEscape(display);

            if (scope.styleMatchedEntries && (!scope.allowFreeEntries || _.filter(combobox.getData(), item => (item as any).id === data.id).length > 0)) {
              return `<i class="fas fa-fw ${scope.icon}" style="padding-right: 5px; color: ${data.color ? data.color : '#428bca'};"></i>${display}`;
            }

            return display;
          },
          maxSelectionRenderer: (data: any) => {
            if (scope.maxSelectionText != undefined) {
              return `${scope.maxSelectionText}`;
            }

            return `You cannot choose more than ${data} item`;
          }
        });

        $(combobox).on("selectionchange", (_, m) => {
          scope.data = m.getSelection().slice(0);
          scope.$apply();
        });

        element.on('input', '.ms-sel-ctn input[type=text]', (e: any) => {
          if (e.originalEvent?.inputType === 'insertFromPaste') {
            combobox.collapse();
            combobox.expand();
          }
        });

        scope.$watch("disabled", value => {
          if (value) {
            combobox.disable();
          } else {
            combobox.enable();
          }
        });

        scope.$watchCollection("data", (d: Array<any>) => {
          if (d && d.length > 0) {
            if (_.union(d, scope.data).length > combobox.getSelection().length) {
              combobox.addToSelection(d, true);
            } else if (_.difference(d, combobox.getSelection()).length > 0) {
              combobox.clear(true);
              combobox.addToSelection(d, true);
            }
          } else {
            combobox.clear(true);
          }
        });

        scope.$watch("serviceUrl", (url: string) => {
          if (url) combobox.setData(`${configService.getServerBaseUrl()}${url}`);
        });

        scope.$watch("options", (data: string) => {
          if (data) {
            combobox.setData(data);
          }
        });
      };
    }

    public static HtmlEscape(str: string): string {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
  }

  frontendApp.directive("iioComboBox", ["ConfigService", "TokenService", "HttpService", Factory.Create(ComboBox)]);
}
